import AppRoutes from './app-route';

const App = () => {
    return <AppRoutes />;
};

export default App;
